import AccountingDashboardStore from "./AccountingDashboard.Store";
import PlantOverviewStore from "../PlantOverview/PlantOverview.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const dashboardRoute: RouteType = {
  name: "Accounting Dashboard",
  path: "/accounting/dashboard",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Accounting Dashboard",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./AccountingDashboard.Header"),
    },
    body: {
      component: () => import("./AccountingDashboard.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  // permissionPath: "accounting.dashboard",
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const accountingDashboardStore =
      rootStore.accountingDashboardStore as AccountingDashboardStore;
    const plantOverviewStore =
      rootStore.plantOverviewStore as PlantOverviewStore;

    // Load both dashboard data and plant data in parallel
    await Promise.all([
      accountingDashboardStore.loadDashboardData(),
      plantOverviewStore?.initializePlants?.(),
    ]);

    return true;
  },
  dialogs: [
    {
      name: "AccountingDueDateDetail",
      title: "Due Date Details",
      component: () => import("./AccountingDashboard.Dialog"),
    },
    {
      name: "ApproveInvoiceDialog",
      title: "Approve Invoice",
      component: () => import("./dialogs/ApproveInvoiceDialog.Body"),
      cancelButton: true,
      height: 650,
    },
    {
      name: "ApproveBillDialog",
      title: "Approve Bill",
      component: () => import("./dialogs/ApproveBillDialog.Body"),
      cancelButton: true,
      height: 700,
    },
    {
      name: "ApprovePODialog",
      title: "Approve Purchase Order",
      component: () => import("./dialogs/ApprovePODialog.Body"),
      cancelButton: true,
      height: 650,
    },
    {
      name: "ApproveICADialog",
      title: "Approve ICA Transaction",
      component: () => import("./dialogs/ApproveICADialog.Body"),
      cancelButton: true,
      height: 650,
    },
  ],
};

export default dashboardRoute;
